import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router";
import { GAMESTATES } from "../../model/game";
import createRedistGame, { getRedisGame } from "../../utils/redisGame";


import { useGame } from "../../viewmodel/hooks/getGame";
import GameResult from "./gameResult";
import GetReadyLoading from "./GetReadyLoading";
import PlayQuestion from "./PlayQuestion";
import ReplayLoading from "./WaitingLoading";

import routes from "../../utils/routes.json";
import { useProfile } from "../../viewmodel/hooks/getProfile";
import { getUserInfo } from "../../viewmodel/providers/userInfo";

import Sound from "react-sound";

/* eslint-disable camelcase */
//import loop_Quizz from "./audio/loop_Quizz.mp3";
//import sou_vitoria from "./audio/sou_vitoria.mp3";
import { SoundContext } from "../../viewmodel/providers/sound-context";


type locationState = {
    channelId: string,
    userId: string,
    opponentId: string;
    categoryIds: string[],
}


export default function Game(): JSX.Element {

    const [state, setGameState, setGame, incrementQuestionNumber, incrementPercentage] = useGame();

    const location: locationState = useLocation<locationState>().state;

    const sound = React.useContext(SoundContext).sound;

    const beforeUnloadHandle = (event: BeforeUnloadEvent): any => {
        const e = event || window.event;
        // Cancel the event
        e.preventDefault();
        if (e) {
            e.returnValue = ""; // Legacy method for cross browser support
        }
        return ""; // Legacy method for cross browser support
    };

    const resetHistory = (event: any) => {
        const e = event || window.event;
        e.preventDefault();
        if (e) {
            e.returnValue = ""; // Legacy method for cross browser support
        }
        return ""; // Legacy method for cross browser support
    };

    useEffect(() => {

        window.addEventListener("unload", resetHistory);
        window.addEventListener("beforeunload", beforeUnloadHandle);


        if (location) {
            const redisGame =
                createRedistGame(location.channelId, location.userId,
                    location.opponentId, state, setGameState, setGame, incrementPercentage);
            return () => {
                redisGame.close();
                window.removeEventListener("unload", resetHistory);
                window.removeEventListener("beforeunload", beforeUnloadHandle);
            };
        }

        return () => {
            window.removeEventListener("unload", resetHistory);
            window.removeEventListener("beforeunload", beforeUnloadHandle);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [user, setProfileUser] = useProfile();
    useEffect(() => {
        if (location !== undefined)
            getUserInfo(location.userId, setProfileUser);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.userId]);

    const redisGame = getRedisGame(setGameState, setGame, incrementPercentage);
    const [opponent, setProfileOpponent] = useProfile();
    useEffect(() => {
        if (redisGame !== undefined)
            getUserInfo(redisGame.opponentId, setProfileOpponent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [redisGame?.opponentId]);

    if (!location)
        return <Redirect to={routes.menu} />;

    let component = <ReplayLoading user={opponent.user} />;
    switch (state.state) {
        case GAMESTATES.START_GAME:
            component = <ReplayLoading user={opponent.user} backButton={false} />;
            break;
        case GAMESTATES.GETREADY:
            {
                const duration = redisGame?.waitingTime || 3;
                component = <GetReadyLoading duration={duration} />;
            }
            break;
        case GAMESTATES.RESTART_QUESTION:
            incrementQuestionNumber();
            setGameState(GAMESTATES.QUESTIONS);
            break;
        case GAMESTATES.SHOW_QUESTION:
            {
                const answers = redisGame?.answers;
                const correctAnswer = answers.correct;
                const oponnentAnswer = answers[location.opponentId];
                component =
                    <PlayQuestion
                        user={user.user} opponent={opponent.user}
                        key={state.questionNumber}
                        question={state.question} options={state.options} duration={state.duration} questionNumber={state.questionNumber}
                        correctOption={correctAnswer} oponnentAnswer={oponnentAnswer}
                        percentageCorrect1={state.percentage1} percentageCorrect2={state.percentage2}
                    />;
            }
            break;
        case GAMESTATES.QUESTIONS:
            component =
                <PlayQuestion
                    user={user.user} opponent={opponent.user}
                    key={state.questionNumber}
                    question={state.question} options={state.options} duration={state.duration} questionNumber={state.questionNumber}
                    percentageCorrect1={state.percentage1} percentageCorrect2={state.percentage2}
                />;
            break;
        case GAMESTATES.ENDGAME:
            {
                const gameId = location.channelId.slice("current:".length, location.channelId.length);
                component =
                    <GameResult
                        winner={redisGame?.winner}
                        gameId={gameId}
                        user={user.user}
                        opponent={opponent.user}
                        oponnentId={location.opponentId}
                        categoryIds={location.categoryIds}
                    />;
            }
            break;
        default:
            break;
    }

    /*const soundComponent = (state.state === GAMESTATES.SHOW_QUESTION || state.state === GAMESTATES.QUESTIONS) ? (
        <Sound
            url={sou_vitoria}
            loop={true}
            playStatus={sound ? "PLAYING" : "STOPPED"}
            volume={7}
        />
    ) : null;*/

    return (
        <span>
            {component}
            {/*soundComponent*/}
        </span>
    );
}
